var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.61095 9.77777V6.22222C9.61095 5.8686 9.47047 5.52946 9.22042 5.27941C8.97038 5.02936 8.63124 4.88888 8.27761 4.88888C7.92399 4.88888 7.58485 5.02936 7.33481 5.27941C7.08476 5.52946 6.94428 5.8686 6.94428 6.22222V12.4444C6.94428 13.0338 7.17841 13.599 7.59516 14.0158C8.0119 14.4325 8.57713 14.6667 9.1665 14.6667C9.45833 14.6667 9.7473 14.6092 10.0169 14.4975C10.2865 14.3858 10.5315 14.2221 10.7379 14.0158C10.9442 13.8094 11.1079 13.5645 11.2196 13.2948C11.3312 13.0252 11.3887 12.7363 11.3887 12.4444V4.44444C11.3887 3.61932 11.0609 2.828 10.4775 2.24455C9.89406 1.66111 9.10273 1.33333 8.27761 1.33333C7.4525 1.33333 6.66117 1.66111 6.07773 2.24455C5.49428 2.828 5.1665 3.61932 5.1665 4.44444V9.77777",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/attachment.44742e2a.svg";
export { ForwardRef as ReactComponent };